export default __webpack_public_path__ + "static/media/service6.3b18a431.jpeg";